module.exports = __webpack_public_path__ + "img/engagement-photo-4.42d51af6.jpg";